import { Square } from "./Square";

export function Board() {
  return (
    <div>
      <div className="board-row">
        <Square square={0} />
        <Square square={1} />
        <Square square={2} />
      </div>
      <div className="board-row">
        <Square square={3} />
        <Square square={4} />
        <Square square={5} />
      </div>
      <div className="board-row">
        <Square square={6} />
        <Square square={7} />
        <Square square={8} />
      </div>
    </div>
  );
}
